import * as constants from '../goals.constants';

export const getGoal = (goalId) => ({ type: constants.GET_GOAL, goalId });

export const clearGoal = () => ({ type: constants.CLEAR_GOAL });

export const createBundle = (locationId, goalId, goalName, rulesTemplates, dealsTemplates, oneTimeActionsTemplates) => ({ type: constants.CREATE_BUNDLE, locationId, goalId, goalName, rulesTemplates, dealsTemplates, oneTimeActionsTemplates });
